import { render, staticRenderFns } from "./ticket-list-item.vue?vue&type=template&id=1f6ed8bc&scoped=true&"
import script from "./ticket-list-item.vue?vue&type=script&lang=js&"
export * from "./ticket-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6ed8bc",
  null
  
)

export default component.exports